import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { authHeader } from '@H';
import { confirmAlert } from 'react-confirm-alert';
import SwipeList from './SwipeList';

const swipeMachines = () => {
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const editRef = useRef(null);
  const [swipeData, setSwipeData] = useState([
    {
      swipe_machine_name: '',
      updated: false,
      editMode: false,
    },
  ]);

  const handleChange = (e) => {
    setSwipeData({
      ...swipeData,
      [e.target.name]: e.target.value,
    });
  };

  const cancelEdit = () => {
    setSwipeData({
      swipe_machine_name: '',
      updated: swipeData.updated,
      editMode: false,
    });
  };

  const handleEditMode = (swipe) => {
    setSwipeData({
      uuid: swipe.uuid,
      swipe_machine_name: swipe.bank_name,
      updated: swipeData.updated,
      editMode: true,
    });
    if (editRef.current) {
      window.scrollTo({
        behavior: 'smooth',
        top: editRef.current.offsetTop - 150,
      });
    }
  };

  const confirmSubmit = (e) => {
    const { swipe_machine_name } = swipeData;
    confirmAlert({
      title: 'Are you sure you want to',
      message: swipeData.editMode
        ? `update ${swipe_machine_name}`
        : 'add a new swipe machine',
      buttons: [
        {
          label: 'Yes',
          onClick: () => submitForm(e),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const headers = authHeader(1);
    const url = `${process.env.API_URL}/utils/swipe-machines/`;
    let method = 'POST';
    let formData = swipeData;
    if (swipeData.editMode) {
      method = 'PUT';
      formData.swipe_machine_name = swipeData.swipe_machine_name;
    }
    axios({
      method,
      url,
      data: formData,
      headers,
    })
      .then(() => {
        toast.success('Swipe machine added successfully');
        window.scrollTo({
          behavior: 'smooth',
          top: editRef.current.offsetTop - 150,
        });
        setIsSubmitting(false);
        setSwipeData({
          swipe_machine_name: '',
          updated: !swipeData.updated,
          editMode: false,
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <section className="widget full-width form-table" ref={editRef}>
        <header>
          <h3> swipe Machines</h3>
        </header>
        <main>
          <div className="form-content">
            <table>
              <thead>
                <tr>
                  <th> Bank Name </th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr className={`${swipeData.editMode ? 'highlight-bg' : ''}`}>
                  <td>
                    <div className="input-wrapper">
                      <input
                        name="swipe_machine_name"
                        type="text"
                        onChange={handleChange}
                        placeholder="Bank name"
                        value={swipeData.swipe_machine_name}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="form-actions">
              <button className="submit" type="submit" onClick={confirmSubmit}>
                Submit
              </button>
              {swipeData.editMode && (
                <button className="red-btn" onClick={cancelEdit}>
                  Cancel
                </button>
              )}
            </div>
          </div>
        </main>
      </section>
      <SwipeList key={swipeData.updated} onEdit={handleEditMode} />
    </>
  );
};

export { swipeMachines };
